/**
 * filename：en.js
 */
export const h = {
  title1: 'List of individual consideration applications',
  back1: 'Return to Home Page',
  contentStr1: 'Apply For Participant Information',
  contentStr2: 'Individual Competition Participant Information',
  contentStr3: ' (Note: As it involves the application for the number of test papers, please fill in the application information carefully. Thank you!)',
  contentStr4: 'Current Competition Season Activities',
  contentStr5: 'Estimated Exam Time',
  contentStr6: 'The school‘s province, city, and district',
  contentStr7: 'School Name',
  contentStr8: 'Participating Grades',
  contentStr9: 'Number of Classes Per Grade',
  contentStr10: 'Estimated Number of Participants',
  contentStr11: 'Remarks (Optional)',
  contentStr12: 'Please Fill in Postscript',
  contentStr13: 'Information for Mailing Address',
  contentStr14: 'Note: As it involves the mailing of competition materials, please fill in the mailing information carefully. Thank you!',
  contentStr15: 'Recipient Name',
  contentStr16: 'Recipient Contact Information',
  contentStr17: 'Email',
  contentStr18: 'Shipping Address',
  contentStr19: 'Detailed Address',
  contentStr20: 'Note: As it involves material preparation, please fill in carefully. Once submitted, this application cannot be amended. If modification is needed, please contact the city committee teacher!',
  contentStr21: 'city committee teacher!',
  contentStr22: 'Submit Information',
  contentStr23: 'Application Successful. Please wait for the committee to contact you.',
  contentStr24: 'Submitted successfully. Please wait patiently while the committee reviews your application.',
  contentStr25: 'ITSOx Team Competition Application',
  contentStr26: 'Submit Information',
  contentStr27: 'Qualification Check',
  contentStr28: 'Make a Payment',
  contentStr29: 'Club Group',
  contentStr30: 'Teacher Name',
  contentStr31: 'Teacher Contact Information',
  contentStr32: 'Proposed Number of Teams',
  contentStr33: 'Club Name',
  contentStr34: '1. ITSO x Team Competition Annual Registration Fee: 480 RMB/team/season;',
  contentStr35: '2. Each school can register up to 2 teams in the same group;',
  contentStr36: '3. Registration is completed only after the committee reviews and confirms the submitted registration information;',
  contentStr37: '4. The registration fee includes: qualification for the 2026-27 ITSOx Team Competition National Finals, participation code certificate, official unified training, 2 official word list manuals for the 2026-27 season, and 1 online word list package;',
  contentStr38: '5. If the registered team pays the annual registration fee but cannot participate in the subsequent competitions of this year due to school or personal reasons, the annual registration fee is non-refundable, but the team still enjoys the above rights;',
  contentStr39: '6. Upon successful registration, the team will receive a certificate with a unique identification code from the committee, which is valid for this year and can be verified on the SPBCN official website;',
  contentStr40: 'Information Review ',
  contentStr41: 'Payment Status',
  contentStr42: 'Unpaid',
  contentStr43: 'Participation Certificate Generated, Click to View',
  contentStr44: 'Review Failed.',
  contentStr45: 'index',
  contentStr46: 'No Estimated Number information available',
  contentStr47: 'Estimated Number',
  contentStr48: 'Estimated Exam Time',
  contentStr49: 'View Details',
  contentStr50: 'Operation',
  contentStr51: 'place select',
  contentStr52: 'place input',
  contentStr53: '(sending the audio used in the exam)',
  contentStr54: 'Example: House number of Unit x, Building x, xx Community, town (street)',
  contentStr55: 'Waiting for Committee to Mail Test Papers',
  contentStr56: 'Waiting to Receive Test Papers',
  contentStr57: 'Go Back',
  contentStr58: 'Review Approved',
  contentStr59: 'Refunded',
  contentStr60: 'Resubmit Registration Information',
  contentStr61: 'Paid',
  contentStr62: 'Participation Certificate',
  contentStr63: 'downLoad',
  contentStr64: 'close',
  contentStr65: 'Reason:',
  contentStr66: ' class ',
  contentStr67: 'school login',
  contentStr68: 'phone number',
  contentStr69: 'Return to Home Page',
  contentStr70: 'phone number',
  contentStr71: 'Please enter phone number',
  contentStr72: 'Verification code',
  contentStr73: 'Enter code',
  contentStr74: 'Login',
  contentStr75: 'Please enter the correct mobile phone number',
  contentStr76: 'SMS sent successfully, please check',
  contentStr77: 'Login success',
  contentStr78: 'Send code',
  contentStr79: 'Teacher in charge',
  contentStr80: 'Regist',
  contentStr81: 'Not yet open, stay tuned!',
  contentStr82: 'Congratulations, successfully registered!',
  contentStr83: 'Tips',
  contentStr84: 'confirm',
  contentStr85: 'Cancel',
  studyPlan1: 'Study Plan',
  studyPlanNoData: 'No study plan has been created yet.',
  studyPlanCreate: 'Create',
  studyPlanCancel: 'Cancel ',
  studyPlanSubmit: 'Submit',
  formItem1: 'Plan Name',
  formItem2: 'Plan Type',
  formItem3: 'First Level Attribute',
  formItem4: 'Second Level Attribute',
  formItem5: 'Start and End Time',
  formTypeWeek: 'Weekly Plan',
  formTypeMonth: 'Monthly Plan',
  formTypeSemester: 'Semester Plan',
  formTypeYear: 'Academic Year Plan',
  rsp: 'to',
  sp: 'Start Date',
  ep: 'End Date',
  np: 'Please enter plan name.',
  tp: 'Please select plan type.',
  rtp: 'Please select start and end time.',
  oneLevelAP: 'Example: Grade',
  oneLevelBP: 'Example: Grade One',
  twoLevelAP: 'Example: Class',
  twoLevelBP: 'Example: 1',
  createTime: 'Creation Time',
  creator: 'Creator',
  state: 'State',
  edit: 'Revise',
  toWord: 'View Word List',
  studyPlan2: 'Study Plan Word List',
  wordListNoData: 'No Word List Data',
  importWords: 'Import Words in Batches',
  importWordsWithScan: 'Import Words with Scanning pen',
  downLoadTemplate: 'Download Template',
  uploadExcel: 'Confirm Upload',
  chooseExcel: 'Select File',
  wordListTip1: '1、Download Excel Template',
  wordListTip2: '2、Modify Files According to Template Requirements',
  wordListTip3: '3、Click the Button Below to Select a File',
  wordListTip4: '4、Click Confirm to Upload',
  spell: 'Word',
  taskType: 'Teaching Task',
  source: 'Source',
  difficulty: 'Difficulty',
  del: 'Delete',
  delAsk: 'Confirm to delete this word?',
  spellP: 'Please enter the word.',
  hadDel: 'Deleted',
  stuP: 'Please enter your name.',
  phoneP: 'Please enter your phone number.',
  importStudent: 'Import Student Name Lists in Batches',
  import: 'Import in Batches',
  studentNoData: 'No Student Data',
  addbtn: 'Add Student',
  stuName: 'Student Name',
  search: 'Inquire',
  reset: 'Reset',
  chooseFileFirst: 'Please select the file to upload.',
  uploadSucc: 'Upload Successfully',
  failReason: 'Please modify and upload again. Reason for failure:',
  failUpload: 'Upload Failed',
  addSucc: 'Added Successfully',
  comfirmToAdd: 'Comfirm to Add',
  state1: 'Normal',
  state2: 'Forbidden',
  delAsk2: 'Confirm to delete this student?',
  base: 'Qualified',
  increase: 'Improve',
  extra: 'Think about it',
  planManagement: 'Plan Management',
  studentManagement: 'Student Management',
  scanNotes1: '1. You need to use WeChat associated with the same phone number to authorize and log in for scanning the pen tool.\n2. On the website Check the selection box on the left side of the plan list that requires word upload, and click the ‘Start Upload’ button at the bottom.\n3. By clicking on the scanned word result from the pen, you can upload that word to the plan.\n4. After the upload is completed, click the ‘End Upload’ button to finish the current upload session.',
  moreOperation: 'More Operations',
  beginUpLoad: 'Begin upLoad',
  endUpLoad: 'End upload',
  upLoadEndTips: 'Are you sure you want to end the current upload task?',
  upLoadEndTips2: '*Please scan using the scanning pen and select the word upload operation. After the upload is complete, please click the ‘End Upload’ button and do not refresh the interface.',
  reloading: 'Loading',
  clickedReloading: 'click refresh',
  competitionPlan: 'Competition plan'
}
